import React from "react";
import { useNavigate } from "react-router-dom";
import { FaDatabase, FaChartBar } from "react-icons/fa";
import Layout from "../../Component/Layout";

// Add / remove cards here as new Assets Management sub-pages are built.
const ASSET_TILES = [
  {
    id: "ASSET_MASTER",
    name: "Asset Master",
    description: "Open Module",
    icon: FaDatabase,
    path: "/finance/assets/asset-master",
  },
  {
    id: "ASSET_REPORT",
    name: "Asset Report",
    description: "Open Module",
    icon: FaChartBar,
    path: "/finance/assets/asset-report",
  },
];

const styles = {
  page: {
    padding: "32px 40px",
  },
  heading: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#1a1a2e",
    marginBottom: "8px",
  },
  subheading: {
    fontSize: "15px",
    color: "#6b7280",
    marginBottom: "28px",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  },
  card: {
    width: "260px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "20px",
    cursor: "pointer",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
  },
  iconWrap: {
    width: "44px",
    height: "44px",
    borderRadius: "10px",
    background: "#eaf1ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  icon: {
    color: "#2f5fdb",
    fontSize: "20px",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#1a1a2e",
    marginBottom: "4px",
  },
  cardLink: {
    fontSize: "13px",
    color: "#8b8fa3",
  },
};

export default function AssetsTile() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div style={styles.page}>
        <h1 style={styles.heading}>Assets Management</h1>
        <p style={styles.subheading}>Manage and view your asset master data and reports.</p>

        <div style={styles.grid}>
          {ASSET_TILES.map((tile) => {
            const Icon = tile.icon;
            return (
              <div
                key={tile.id}
                style={styles.card}
                onClick={() => navigate(tile.path)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.04)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <div style={styles.iconWrap}>
                  <Icon style={styles.icon} />
                </div>
                <div style={styles.cardTitle}>{tile.name}</div>
                <div style={styles.cardLink}>{tile.description} →</div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}